<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post-13_lebanon-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post-13_lebanon-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.77152278163876;"
    data-aspect-ratio="0.772"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post-13_lebanon-xs-img"
      class="g-post-13_lebanon-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-13_lebanon-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:11.6699%;margin-top:-8.9px;left:16.7936%;width:44px;"
    >
      <p class="g-pstyle0">IRAN</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.0466%;margin-top:-8.1px;right:54.2115%;width:57px;"
    >
      <p class="g-pstyle1">Tripoli</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:24.5674%;margin-top:-8.1px;left:42.9982%;width:93px;"
    >
      <p class="g-pstyle2">LEBANON</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.5823%;margin-top:-30.6px;left:77.8181%;width:89px;"
    >
      <p class="g-pstyle3">Evacuation</p>
      <p class="g-pstyle3">issued by</p>
      <p class="g-pstyle3">the Israeli</p>
      <p class="g-pstyle3">military</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.2552%;margin-top:-8.1px;right:78.8019%;width:62px;"
    >
      <p class="g-pstyle4">Beirut</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.2987%;margin-top:-8.1px;left:31.5159%;width:80px;"
    >
      <p class="g-pstyle5">Airstrikes</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.8394%;margin-top:-12px;right:30.3985%;width:53px;"
    >
      <p class="g-pstyle6">SYRIA</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:88.3934%;margin-top:-23.1px;left:41.8035%;width:89px;"
    >
      <p class="g-pstyle3">Area under</p>
      <p class="g-pstyle3">evacuation</p>
      <p class="g-pstyle3">order</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.8748%;margin-top:-8.1px;left:73.6117%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle7">25km</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.5568%;margin-top:-12px;right:79.0566%;width:59px;"
    >
      <p class="g-pstyle6">ISRAEL</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.6954%;margin-top:-8.9px;left:3.7413%;width:65px;"
    >
      <p class="g-pstyle0">LEBANON</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post-13_lebanon-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.00771249326871;"
    data-aspect-ratio="1.008"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post-13_lebanon-sm-img"
      class="g-post-13_lebanon-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-13_lebanon-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.629%;margin-top:-11.9px;left:15.3157%;width:44px;"
    >
      <p class="g-pstyle0">IRAN</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:17.2228%;margin-top:-12.2px;right:52.9262%;width:62px;"
    >
      <p class="g-pstyle1">Tripoli</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.1428%;margin-top:-12.2px;left:46.9215%;width:114px;"
    >
      <p class="g-pstyle2">LEBANON</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.4238%;margin-top:-38.7px;left:76.3526%;width:104px;"
    >
      <p class="g-pstyle3">Evacuation</p>
      <p class="g-pstyle3">issued by</p>
      <p class="g-pstyle3">the Israeli</p>
      <p class="g-pstyle3">military</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:49.0431%;margin-top:-12.2px;right:70.0452%;width:67px;"
    >
      <p class="g-pstyle4">Beirut</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.3177%;margin-top:-10.2px;left:37.7773%;width:92px;"
    >
      <p class="g-pstyle5">Airstrikes</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.7964%;margin-top:-24.7px;left:1.2674%;width:99px;"
    >
      <p class="g-pstyle6">Area under</p>
      <p class="g-pstyle6">evacuation</p>
      <p class="g-pstyle6">order</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.5198%;margin-top:-12.1px;right:28.7659%;width:58px;"
    >
      <p class="g-pstyle7">SYRIA</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.0547%;margin-top:-8.6px;left:65.4519%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle8">25km</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.033%;margin-top:-12.1px;right:55.1534%;width:65px;"
    >
      <p class="g-pstyle7">ISRAEL</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.4796%;margin-top:-11.9px;left:3.4968%;width:65px;"
    >
      <p class="g-pstyle0">LEBANON</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post-13_lebanon-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 1199px;aspect-ratio: 1.23166138481228;"
    data-aspect-ratio="1.232"
    data-min-width="660"
    data-max-width="1199"
  >
    <div
      id="g-post-13_lebanon-md-img"
      class="g-post-13_lebanon-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-13_lebanon-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.1669%;margin-top:-11.9px;left:21.7547%;width:44px;"
    >
      <p class="g-pstyle0">IRAN</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.4528%;margin-top:-12.2px;right:46.775%;width:62px;"
    >
      <p class="g-pstyle1">Tripoli</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.9328%;margin-top:-12.2px;left:53.1074%;width:114px;"
    >
      <p class="g-pstyle2">LEBANON</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs"
      style="top:33.5908%;left:73.8799%;width:23.6364%;"
    >
      <p class="g-pstyle3">Evacuation issued by the Israeli military</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.5055%;margin-top:-12.2px;right:60.0033%;width:67px;"
    >
      <p class="g-pstyle4">Beirut</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.6496%;margin-top:-10.2px;left:46.1929%;width:92px;"
    >
      <p class="g-pstyle5">Airstrikes</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.3305%;margin-top:-12.1px;right:29.2275%;width:58px;"
    >
      <p class="g-pstyle6">SYRIA</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:74.8711%;margin-top:-29.2px;left:10.2921%;width:104px;"
    >
      <p class="g-pstyle7">Area under</p>
      <p class="g-pstyle7">evacuation</p>
      <p class="g-pstyle7">order</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.2192%;margin-top:-8.6px;left:67.4263%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle8">25km</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.0023%;margin-top:-12.1px;right:54.0276%;width:65px;"
    >
      <p class="g-pstyle6">ISRAEL</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:10.0614%;margin-top:-11.9px;left:12.6219%;width:65px;"
    >
      <p class="g-pstyle0">LEBANON</p>
    </div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post-13_lebanon-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-post-13_lebanon-xl-img"
      class="g-post-13_lebanon-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-13_lebanon-xl.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-06 16:29 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-06 16:29 -->
<!-- ai file: post-13_lebanon.ai -->
<style lang="scss">
  #g-post-13_lebanon-box {
    container-type: inline-size;
    container-name: g-post-13_lebanon-box;
  }
  #g-post-13_lebanon-box,
  #g-post-13_lebanon-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-13_lebanon-box p {
    margin: 0;
  }
  #g-post-13_lebanon-box .g-aiAbs {
    position: absolute;
  }
  #g-post-13_lebanon-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-13_lebanon-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post-13_lebanon-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-13_lebanon-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-13_lebanon-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-13_lebanon-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-13_lebanon-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 1199px) {
      #g-post-13_lebanon-md {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post-13_lebanon-xl {
        display: block !important;
      }
    }
  }
  #g-post-13_lebanon-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-13_lebanon-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(18, 50, 98);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-13_lebanon-xs .g-pstyle0 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 7px;
    font-size: 10px;
    color: rgb(64, 64, 64);
  }
  #g-post-13_lebanon-xs .g-pstyle1 {
    font-weight: 300;
    height: 15px;
    padding-bottom: 7px;
    text-align: right;
    color: rgb(161, 161, 161);
  }
  #g-post-13_lebanon-xs .g-pstyle2 {
    font-weight: 700;
    height: 15px;
    padding-bottom: 7px;
    letter-spacing: 0.1em;
    color: rgb(64, 64, 64);
  }
  #g-post-13_lebanon-xs .g-pstyle3 {
    font-weight: 700;
    height: 15px;
  }
  #g-post-13_lebanon-xs .g-pstyle4 {
    font-weight: 700;
    height: 15px;
    padding-bottom: 7px;
    font-size: 15px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-post-13_lebanon-xs .g-pstyle5 {
    font-weight: 700;
    height: 15px;
    color: rgb(176, 42, 41);
  }
  #g-post-13_lebanon-xs .g-pstyle6 {
    font-weight: 300;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    font-size: 12px;
    text-align: right;
    color: rgb(161, 161, 161);
  }
  #g-post-13_lebanon-xs .g-pstyle7 {
    font-weight: 400;
    height: 15px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-13_lebanon-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-13_lebanon-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 17px;
    text-align: left;
    color: rgb(18, 50, 98);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-13_lebanon-sm .g-pstyle0 {
    font-weight: 300;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    font-size: 10px;
    color: rgb(64, 64, 64);
  }
  #g-post-13_lebanon-sm .g-pstyle1 {
    font-weight: 300;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: right;
    color: rgb(161, 161, 161);
  }
  #g-post-13_lebanon-sm .g-pstyle2 {
    font-weight: 700;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    letter-spacing: 0.1em;
    font-size: 18px;
    color: rgb(64, 64, 64);
  }
  #g-post-13_lebanon-sm .g-pstyle3 {
    font-weight: 700;
    height: 19px;
  }
  #g-post-13_lebanon-sm .g-pstyle4 {
    font-weight: 700;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-post-13_lebanon-sm .g-pstyle5 {
    font-weight: 700;
    height: 19px;
    color: rgb(176, 42, 41);
  }
  #g-post-13_lebanon-sm .g-pstyle6 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 16px;
  }
  #g-post-13_lebanon-sm .g-pstyle7 {
    font-weight: 300;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: right;
    color: rgb(161, 161, 161);
  }
  #g-post-13_lebanon-sm .g-pstyle8 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-13_lebanon-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-13_lebanon-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 17px;
    text-align: left;
    color: rgb(18, 50, 98);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post-13_lebanon-md .g-pstyle0 {
    font-weight: 300;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    font-size: 10px;
    color: rgb(64, 64, 64);
  }
  #g-post-13_lebanon-md .g-pstyle1 {
    font-weight: 300;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: right;
    color: rgb(161, 161, 161);
  }
  #g-post-13_lebanon-md .g-pstyle2 {
    font-weight: 700;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    letter-spacing: 0.1em;
    font-size: 18px;
    color: rgb(64, 64, 64);
  }
  #g-post-13_lebanon-md .g-pstyle3 {
    font-weight: 700;
  }
  #g-post-13_lebanon-md .g-pstyle4 {
    font-weight: 700;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-post-13_lebanon-md .g-pstyle5 {
    font-weight: 700;
    height: 19px;
    color: rgb(176, 42, 41);
  }
  #g-post-13_lebanon-md .g-pstyle6 {
    font-weight: 300;
    line-height: 23px;
    height: 23px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: right;
    color: rgb(161, 161, 161);
  }
  #g-post-13_lebanon-md .g-pstyle7 {
    font-weight: 700;
    height: 19px;
  }
  #g-post-13_lebanon-md .g-pstyle8 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-13_lebanon-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-13_lebanon-xl p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-13_lebanon-xl .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-post-13_lebanon-xl .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-13_lebanon-xl .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
</style>
